export enum BrandingTypes {
    MICROMATE = 'micromate',
    TASKBASE = 'taskbase',
}
